const getters = {
  dialogsModal: (state) => state.dialogs.modal,
  dialogsCloseOnEscape: (state) => state.dialogs.closeOnEscape,
  dialogsDismissableMask: (state) => state.dialogs.dismissableMask,
  layout: (state) => state.layout,
  showSidebar: (state) => state.showSidebar,
  sqlCode: (state) => state.sqlCode,
  graphs: (state) => state.graphs,
  triggerImpersonationUser: (state) => state.triggerImpersonationUser,
  loadingUserGroups: (state) => state.loadingUserGroups,
  closingSession: (state) => state.closingSession,
};

export default getters;
